<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("mcg.gcm") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5 pb-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 sm3 md3 lg3 ml-2>
                    <v-btn
                      color="#077893"
                      outlined
                      to="/consent-management-group-add"
                    >
                      <v-icon class="mr-1">mdi-plus</v-icon>
                      {{ $t("mcg.cregroup") }}
                    </v-btn>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 sm6 md4 lg4 mr-2>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-card outlined>
                  <v-data-table
                    :headers="headers"
                    :items="ItemGroup"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.GroupId`]="{ item }">
                      <td class="text-center">
                        <div
                          class="text-center"
                          v-if="item.GroupId === '' || item.GroupId === null"
                        >
                          -
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === true"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(item.GroupId)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ item.GroupId }}
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === false"
                        >
                          ...
                        </div>
                        <center>
                          <v-btn
                            icon
                            color="#077893"
                            @click="fn_seeEmailAnalysis(item)"
                            text
                            ><v-icon>{{
                              item.see_id === true
                                ? "mdi-eye-off"
                                : "mdi-eye-settings"
                            }}</v-icon>
                          </v-btn>
                        </center>
                      </td>
                    </template>
                    <!-- <template v-slot:[`item.GroupName`]="{ item }">
                    {{ item.GroupName }}
                  </template> -->
                    <template v-slot:[`item.GroupName`]="{ item }">
                      <div v-if="item.GroupName.length < 25">
                        {{ item.GroupName }}
                      </div>
                      <div v-else>
                        <v-tooltip top color="#077893" max-width="80vh">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{
                              item.GroupName.slice(0, 25)
                            }}</span>
                          </template>
                          <span>{{ item.GroupName }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeBy`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeBy }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeByEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeAt }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Manage`]="{ item }">
                      <div v-if="item.Manage === 'draft'">
                        <v-chip color="orange" small dark>{{
                          $t("policy.text1")
                        }}</v-chip>
                      </div>
                      <div v-else-if="item.Manage === 'enable'">
                        <v-chip color="success" small dark>{{
                          $t("policy.text2")
                        }}</v-chip>
                      </div>
                      <div v-else>
                        <v-chip color="error" small dark>{{
                          $t("policy.text3")
                        }}</v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <div
                        class="d-flex justify-center"
                        style="position: relative; left: 0.5rem"
                      >
                        <v-switch
                          @change="Fn_ChangeStatus(item, '')"
                          class="text-center"
                          color="green"
                          v-model="item.Status"
                          inset
                          dense
                        ></v-switch>
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            color="#077893"
                            @click="Fn_ViewDetail(item)"
                            dark
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                        <span> {{ $t("consentlist.detail") }}</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>
                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex'

const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      ItemPerPage: 30,
      Search: '',
      ItemGroup: [],
      ItemDelete: [],
      DialogDelete: false,
      loadingDownloadData: false,
      DataSimilar: null,
      headers: [],
      Role: []
    }
  },
  computed: {
    ...mapGetters(['RoleAccount']),
    ...mapGetters(['Business']),
    DataCheckRole: {
      get () {
        return this.$store.state.DataCheckRole
      }
    },
    _RoleAccount: {
      get () {
        return this.RoleAccount || '-'
      }
    }
  },
  mounted () {
    this.Fn_CheckRole()
    this.Fn_GetDataConsentGroup()
  },
  methods: {
    async Fn_CheckRole () {
      var payload = {
        TaxId: this.$cookies.get('TaxIdCMP')
      }

      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'business/GetBusinessCheckRoleApprove',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.Role = response.data.Message.RoleApprove
            const roleArray = Array.isArray(this.Role)
              ? this.Role
              : [this.Role]
            const roleLowerCase = roleArray.map((role) => role.toLowerCase())

            const dataCheckRoleArray = Array.isArray(this.DataCheckRole)
              ? this.DataCheckRole
              : [this.DataCheckRole]
            const dataCheckRoleLowerCase = dataCheckRoleArray.map((role) =>
              role.toLowerCase()
            )

            this.DataSimilar = roleLowerCase.some((role) =>
              dataCheckRoleLowerCase.includes(role)
            )
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    async Fn_ChangeStatus (val) {
      var payload = {
        GroupId: val.GroupId,
        BusinessId: val.BusinessId,
        AccountId: this.$cookies.get('OneAccountId'),
        Status: val.Status
        // ReferenceVersion: false,
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'group-consent/UpdateStatusGroupConsent',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            Toast.fire({
              icon: 'success',
              // title: response.data.Message,
              title: this.$i18n.t('alert.upgroup')
            })
          } else {
            val.Status = false
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          val.Status = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    async Fn_GetDataConsentGroup () {
      this.loadingDownloadData = true
      var payload = {
        BusinessId: this.$cookies.get('BusinessId'),
        AccountId: this.$cookies.get('OneAccountId'),
        RoleAccount: this.$cookies.get('RoleAccountId')
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'group-consent/GetAllGroupConsent',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.Fn_SetHeaderByRole()
            this.ItemGroup = response.data.Message

            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1
            var nextPage = startPage + this.ItemGroup.length

            var number = []
            for (var i = startPage; i < nextPage; i++) {
              number.push(i)
            }
            for (var j in this.ItemGroup) {
              this.ItemGroup[j].no = number[j]
            }
            for (var j in this.ItemGroup) {
              this.ItemGroup[j].see_id = false
            }
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
          this.$router.push('/profile')
        })
    },
    async Fn_CopyDetail (val) {
      await navigator.clipboard.writeText(val)
    },
    Fn_UpdateData (val) {
      this.$store.dispatch('SET_DATA_CONSENT_GROUP', val)
      this.$router.push('/consent-management-group-update')
    },
    Fn_ViewDetail (val) {
      if (val.Manage === 'enable') {
        this.$router.push('/consent-management-group-detail')
        this.$store.dispatch('SET_DATA_CONSENT_GROUP', val)
      } else {
        this.$router.push('/consent-management-group-edit')
        this.$store.dispatch('SET_DATA_CONSENT_GROUP', val)
      }
    },
    fn_seeEmailAnalysis (item) {
      if (item.see_id === true) {
        const objIndex = this.ItemGroup.findIndex((arr) => arr.no === item.no)
        const objdata = this.ItemGroup.find((arr) => arr.no === item.no)
        objdata.see_id = false
        this.ItemGroup.splice(objIndex, 1, objdata)
      } else if (item.see_id === false) {
        const objIndex = this.ItemGroup.findIndex((arr) => arr.no === item.no)
        const objdata = this.ItemGroup.find((arr) => arr.no === item.no)
        objdata.see_id = true
        this.ItemGroup.splice(objIndex, 1, objdata)
      }
    },
    Fn_SetHeaderByRole () {
      this.headers = []
      if (this.DataSimilar === true || this.Role.length === 0) {
        this.headers = [
          {
            text: this.$i18n.t('dashboard.num'),
            value: 'no',
            sortable: false,
            align: 'center'
          },
          {
            text: this.$i18n.t('mcg.row1'),
            align: 'center',
            sortable: false,
            value: 'GroupId'
          },
          {
            text: this.$i18n.t('mcg.row2'),
            align: 'left',
            sortable: false,
            value: 'GroupName'
          },
          {
            text: this.$i18n.t('mcg.row3'),
            value: 'UpdatdeBy',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('dashboard.create'),
            value: 'UpdatdeAt',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('dashboard.status'),
            value: 'Status',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('policy.text7'),
            value: 'Manage',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('mcg.row5'),
            value: 'action',
            align: 'center',
            sortable: false
          }
        ]
      } else {
        this.headers = [
          {
            text: this.$i18n.t('dashboard.num'),
            value: 'no',
            sortable: false,
            align: 'center'
          },
          {
            text: this.$i18n.t('mcg.row1'),
            align: 'center',
            sortable: false,
            value: 'GroupId'
          },
          {
            text: this.$i18n.t('mcg.row2'),
            align: 'left',
            sortable: false,
            value: 'GroupName'
          },
          {
            text: this.$i18n.t('mcg.row3'),
            value: 'UpdatdeBy',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('dashboard.create'),
            value: 'UpdatdeAt',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('policy.text7'),
            value: 'Manage',
            align: 'left',
            sortable: false
          },
          {
            text: this.$i18n.t('mcg.row5'),
            value: 'action',
            align: 'center',
            sortable: false
          }
        ]
      }
    }
  }
}
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
